import { EndFlikIcon, ShareScreenIcon } from './icons';
import {
  SearchContentProvider,
  SearchProviderContext,
  SearchResultItem,
} from './types';

export class SessionActionsProvider implements SearchContentProvider {
  id = 'session-actions-provider';
  name = 'Session Actions Provider';
  priority = 110; // Highest priority - appears before system actions

  getResults(context: SearchProviderContext): SearchResultItem[] {
    const { hasSession, isLoggedIn } = context;
    const results: SearchResultItem[] = [];

    // Only show session actions when logged in
    if (!isLoggedIn) {
      return results;
    }

    // Session actions are always shown regardless of badges
    if (hasSession) {
      // Show session actions when a session is active
      results.push({
        id: 'share-screen',
        title: 'Share screen',
        subtitle: 'Select screens to share with your Flik session',
        type: 'action',
        priority: 110,
        action: 'navigate',
        actionKey: 'share-screen', // Navigate to the share-screen action
        icon: <ShareScreenIcon />,
        skipBadgeFiltering: true, // Always show regardless of badges
      });

      results.push({
        id: 'end-flik',
        title: 'End Flik',
        subtitle: 'Stop the current Flik session',
        type: 'action',
        priority: 110,
        action: 'navigate',
        actionKey: 'end-flik', // Navigate to the end-flik action
        icon: <EndFlikIcon />,
        skipBadgeFiltering: true, // Always show regardless of badges
      });
    }

    return results;
  }

  isActive(context: SearchProviderContext): boolean {
    // Session actions are only active when logged in
    return context.isLoggedIn;
  }
}
